import React, { useState } from 'react';
import { useHistory } from "react-router-dom";
import { InventoryTab, inventoryTabTarget } from './inventoryTabNavigation';
import Card from "../../../components/Cards/Card";
import { Col, Row } from 'react-bootstrap';
import { Field } from '../../../components/Common/Field/Field';
import { useTranslation } from 'react-i18next';
import Loader from '../../../components/Common/Loader';
import moment from 'moment';
import { ErrorMessage } from '../../../components/Notifications/Notifications';
import useInventoryCart from '../Hooks/useInventoryCart';
import { DestinationType, MoveTypes } from '../../../api/Inventory/Entities/InventoryMovementEntities';
import { AssignmentType } from '../../../api/Inventory/Entities/InventoryEntities';
import useOperationConfirmation from '../Hooks/useOperationConfirmation';
import { useFormModal } from '../../../components/Modals/formModal.js/FormModal';
import ReleaseList from '../Shared/ReleaseList';
import { Tooltip } from '../../../components/Utils/Tooltips';
import { Add, Remove } from '../../../components/Icons/Icons';
import { FormGroup } from 'react-bootstrap'
import ExpirationWarning from '../Shared/ExpirationWarning';
import { buildLotConsumption, hasInvalidConfirmedQuantities, isConfirmationWithinAvailable, resolveConfirmableQuantity, resolveRemainingStock, selectItemConsumption } from '../Shared/inventoryFormRules';
import { QuantityInput } from '../Shared/QuantityInput';


function LinkedNode(uniqueId, childUniqueId = null, fatherUniqueId = null) {
    this.uniqueId = uniqueId;
    this.childUniqueId = childUniqueId;
    this.fatherUniqueId = fatherUniqueId;
}

export function PharmacyDispenseConfirmPage({ match: { params } }) {
    const history = useHistory();
    const { t } = useTranslation();
    const { dispenseId } = params
    const [move, isLoading, actions] = useInventoryCart(dispenseId, MoveTypes.PharmacyDispenseRequest.Name, AssignmentType.General.Name, null);
    const [Modal, modalActions] = useOperationConfirmation({ destinationType: DestinationType.PharmacyPatient });
    const [selectedReleases, setSelectedReleases] = useState({})
    const [render, setRender] = useState(0)
    const [uniqueIds, setUniqueId] = useState([])
    const [ReleaseModal, ReleaseActions] = useFormModal({ FormContent: ReleaseList })

    if (move == null || move.id == 0) return (<Loader isLoading={true}></Loader>)
    const handleCancel = () => {
        history.push(inventoryTabTarget(InventoryTab.pharmacy))
    }

    const handleConfirmationChange = (item, confirmation) => {
        if (!isConfirmationWithinAvailable(item, confirmation)) return
        confirmation = parseInt(confirmation)
        try {
            item.confirmQuantity(confirmation)
        } catch (e) {
            ErrorMessage(t('inventory.dispense.invalidConfirmedQuantity'))
        }
    }

    const handleShowReleaseModal = async (item) => {
        const id = item.id > 0 ? item.item.id : item.item.inventoryItemId
        const consumedByOtherRows = buildLotConsumption(move.items, item)
        const consumedFromThisItem = selectItemConsumption(consumedByOtherRows, id)
        await ReleaseActions.Show({
            title: t('inventory.commons.lotNumber'),
            onConfirmation: (release) => {
                if (release != null) {
                    item.release = release
                    item.availableQuantity = resolveRemainingStock(release, consumedFromThisItem)
                    selectedReleases[id] = [...(selectedReleases[id] ?? []), release];
                } else {
                    item.release = null
                    item.availableQuantity = 0
                    selectedReleases[id] = []
                }
                setSelectedReleases(selectedReleases)
                shouldRender()
            },
            initValue: { itemId: id, assignmentType: AssignmentType.General.Name, assignId: null, filteredFrom: consumedByOtherRows, includeExpired: false }
        })
        shouldRender()
    }

    const onCleanSelectedRelease = (item, release) => {
        const id = item.id > 0 ? item.item.id : item.item.inventoryItemId
        selectedReleases[id] = selectedReleases[id]?.filter(x => x.lotNumber != release.lotNumber) ?? []
        item.release = null;
        setSelectedReleases(selectedReleases)
        shouldRender()
    }

    async function onHandleSubmit() {

        const areAllZero = move.items.every(x => x.confirmedQuantity == 0)

        if (areAllZero) {
            ErrorMessage("inventory.dispense.atLeastOneConfirmation")
            return
        }

        if (hasInvalidConfirmedQuantities(move.items)) {
            ErrorMessage(t('inventory.dispense.invalidConfirmedQuantity'))
            return
        }

        await modalActions.confirmDispense({
            move: move,
            succeededCallback: () => history.push(inventoryTabTarget(InventoryTab.pharmacy))
        })
    }

    async function handleCancelMovement() {
        await modalActions.cancelDispenseOperation({
            move,
            succeededCallback: () => history.push(inventoryTabTarget(InventoryTab.pharmacy))
        })
    }



    const handleCloneItem = (sourceItem) => {
        const fixedQuantity = (sourceItem.quantity - sourceItem.confirmedQuantity);

        const childUniqueId = actions.AddItem({
            ...sourceItem.item,
            inventoryItemId: sourceItem.id > 0 ? sourceItem.item.id : sourceItem.item.inventoryItemId
        }, null, fixedQuantity, sourceItem.assignment, 0)

        const father = uniqueIds.find(x => x.childUniqueId == sourceItem.uniqueId)
        const link = new LinkedNode(sourceItem.uniqueId, childUniqueId, father)
        setUniqueId([...uniqueIds, link])
    }

    async function handleRemoveCloneItem(item) {
        actions.RemoveItem(item)
        setUniqueId([...uniqueIds.filter(x => x.childUniqueId != item.uniqueId)])
    }

    const shouldRender = () => setRender(Math.random());

    return (<>
        <Card
            content={<>
                <Loader isLoading={isLoading}>
                    <div className='text-center'>
                        <label className="info-title info-title-lg">{t('inventory.dispense.protocolDispenseConfirmTitle')}</label>
                    </div>
                    <Row>
                        <Col md={4} sm={12}>
                            <div className="info" style={{ justifyContent: 'space-between!important' }}>
                                <Field title={'ID'} value={move.id} spaceType={'between'} />
                                <Field title={t('commons.type')} spaceType={'between'} value={t(`inventory.movements.moveType.${move.moveType?.toLowerCase()}`)} />
                            </div>
                        </Col>
                        <Col md={4} sm={12}>
                            <div className="info" style={{ justifyContent: 'space-between!important' }}>
                                <Field title={t('commons.status')} spaceType={'between'} value={t('inventory.dispense.pendingOfConfirmation')} />
                                <Field title={t('commons.date')} spaceType={'between'} value={moment(move.createAt).format("DD/MM/YYYY HH:mm")} />
                            </div>
                        </Col>
                        <Col md={4} sm={12}>
                            <div className="info" style={{ justifyContent: 'space-between!important' }}>
                                <Field title={t('commons.patient')} spaceType={'between'}
                                    value={move?.destination?.destinationName}
                                />
                            </div>
                        </Col>
                        <Col sm={12}>
                            <div>
                                <hr />
                                <div className='text-center' style={{ marginTop: "1rem" }}>
                                    <strong className='info-label'>{t('inventory.commons.detail')}</strong>
                                </div>
                                <div style={{ height: '500px', overflow: 'hidden auto' }}>

                                    <table className='table table-hover table-condensed table-spaced table-spaced-small'>
                                        <thead>
                                            <tr>
                                                <th style={{ width: '4rem' }}>{t('commons.description')}</th>
                                                <th style={{ width: '2rem' }}>{t('commons.quantity')}</th>
                                                <th style={{ width: '3rem' }}>{t('inventory.commons.lotNumber')}</th>
                                                <th style={{ width: '2rem' }}>{t('inventory.dispense.confirmedQuantity')}</th>
                                                <th style={{ width: '3rem' }}></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {move.items.map((row, index) => {

                                                return (<tr>
                                                    <td>{row.item.presentation}</td>
                                                    <td>{row.quantity}</td>
                                                    <td>
                                                        {row?.release == null && <div className='input-group-container' style={{ justifyContent: 'center' }}>
                                                            <FormGroup>
                                                                <button className="btn btn-primary" disabled={row.release != null} onClick={_ => handleShowReleaseModal(row)}>
                                                                    <Tooltip>
                                                                        <Add /> {t('inventory.dispense.selectLotNumber')}
                                                                    </Tooltip>
                                                                </button>
                                                            </FormGroup>
                                                        </div>
                                                            || <div style={{ justifyContent: 'center', display: "flex", flexDirection: "column" }}>
                                                                <div className='input-group-container' style={{ justifyContent: 'center' }}>
                                                                    <FormGroup>
                                                                        <input disabled={true} value={row?.release?.lotNumber} className="rbt-input-main form-control rbt-input" />
                                                                    </FormGroup>
                                                                    <FormGroup>
                                                                        <button className="btn btn-danger" disabled={row?.release == null} onClick={_ => onCleanSelectedRelease(row, row.release)}>
                                                                            <Tooltip tooltip={t('commons.clear')} id={"tooltipedit-limpiarpaciente"}>
                                                                                <span aria-hidden="true"><Remove /></span>
                                                                            </Tooltip>
                                                                        </button>
                                                                    </FormGroup>
                                                                </div>
                                                                <ExpirationWarning moveItem={row} />
                                                            </div>}
                                                    </td>
                                                    <td>
                                                        <QuantityInput
                                                            value={row.confirmedQuantity}
                                                            min={0}
                                                            allowEmpty={false}
                                                            disabled={row.release == null}
                                                            max={resolveConfirmableQuantity(row)}
                                                            onChange={quantity => {
                                                                handleConfirmationChange(row, quantity)
                                                                shouldRender()
                                                            }} />
                                                    </td>
                                                    <td>
                                                        <button className='btn btn-warning'
                                                            disabled={row.release == null || (row.availableQuantity >= row.quantity) || row.confirmedQuantity == 0
                                                                || uniqueIds.some(x => x.uniqueId == row.uniqueId)}
                                                            onClick={_ => handleCloneItem(row)}>Separar</button>

                                                        {row.id == 0 && <button className='btn btn-danger ' style={{ marginLeft: '1rem' }}
                                                            disabled={uniqueIds.some(x => x.uniqueId == row.uniqueId)}
                                                            onClick={_ => handleRemoveCloneItem(row)}>Eliminar</button>}
                                                    </td>
                                                </tr>)
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <div style={{ textAlign: 'right', display: 'flex', justifyContent: 'end' }}>
                                <button className="btn btn-secondary" type="button" onClick={handleCancel}>{t('buttons.back')}</button>
                                <button type="button" style={{ marginLeft: '1rem' }} className='btn btn-warning' disabled={false} onClick={handleCancelMovement}>{t('buttons.cancel')}</button>
                                <button type="button" style={{ marginLeft: '1rem' }} className='btn btn-success' disabled={false} onClick={onHandleSubmit}>{t('buttons.finish')}</button>
                            </div>
                        </Col>
                    </Row>
                </Loader>
            </>}
        />
        <Modal />
        <ReleaseModal />
    </>)
}